import React from 'react';

import * as Styled from './Tag.styles';

export const Tag = ({ text }: TagComponent) => <Styled.ActionTag className="action-tag" href="#take-action"><Styled.Tag title={text}>{text}</Styled.Tag></Styled.ActionTag>;
